import {
  Grid,
  Row,
  Col,
  FormControl,
  ControlLabel,
  Checkbox,
  Radio,
} from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import Card from "components/Card/Card.jsx";
import "./pickUpModal.css";
import Button from "components/CustomButton/CustomButton.jsx";
import Select from "react-select";
import NotificationSystem from "react-notification-system";
import Collapsible from "react-collapsible";
import Switch from "react-switch";

const AddPickUpOrder = (props) => {
  const _notificationSystem = React.createRef();
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;

  const handleCollectItemChange = (isChecked) => {
    props.setIsCollectItem(isChecked);

    if (!isChecked) {
      props.setDeliveryType && props.setDeliveryType("1");
      props.setPaymentoption && props.setPaymentoption("");
      props.setIsInjectable && props.setIsInjectable(false);
      props.setPaymentOptionError && props.setPaymentOptionError(null);
    }
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <Card
              content={
                <form className="package-details-form">
                  <div className="form-section no-animate">
                    <div className="section-header-po">
                      <h4>
                        <i className="fa fa-tag"></i>
                        Pick Up Order Details
                      </h4>
                    </div>
                    <div className="section-content">
                      <div className="form-row">
                        <div>
                          <label>
                            SUBSCRIBERS <span className="required">*</span>
                          </label>
                          <Select
                            placeholder="Select Supplier"
                            options={props.leadsOptions}
                            value={props.supplierOption}
                            onChange={(val) => {
                              props.setSupplierOption(val);
                              props.setLeadError(null);
                            }}
                            onInputChange={(value) =>
                              props.getAllLeadsDetails(value)
                            }
                            isDisabled={props.isEdit}
                          />
                          {props.leadError}
                        </div>
                        <div>
                          <label>CONTACT NAME</label>
                          <FormControl
                            className="form-control"
                            type="text"
                            placeholder="Contact Name"
                            value={props.contactName}
                            onChange={(e) =>
                              props.setContactName(e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div
                        className="form-row"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <div className="contact-wrapper" style={{ flex: "1" }}>
                          <label>CONTACT PERSON</label>

                          <div style={{ display: "flex" }}>
                            <select
                              className="form-control"
                              style={{ width: "80px" }}
                              value={props.selectMobileNumber}
                              disabled
                              onChange={(e) =>
                                props.setSelectMobileNumber(e.target.value)
                              }
                            >
                              <option value="+94">+94</option>
                              <option value="+91">+91</option>
                            </select>
                            <Col md={12}>
                              <FormControl
                                className="form-control"
                                style={{
                                  flex: "1",
                                  marginTop: "0",
                                  width: "46.5%",
                                }}
                                type="number"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                placeholder="Enter Mobile Number"
                                value={props.mobileNumber}
                                onChange={(e) =>
                                  props.setMobileNumber(e.target.value)
                                }
                              />
                              {props.mobileNumber.length > 0 &&
                                props.mobileNumber.length < 9 && (
                                  <small style={{ color: "red" }}>
                                    Mobile number must be 10 digits
                                  </small>
                                )}
                            </Col>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {props.supplierOption && (
                    <div className="form-section">
                      <div className="section-header-po">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <h4>
                            <i className="fa fa-tag"></i>
                            Address Details
                          </h4>
                          {props.supplierOption && (
                            <div style={{ display: "flex", gap: "5px" }}>
                              <button
                                type="button"
                                className="btn-address"
                                onClick={props.onAddAddressClick}
                              >
                                <i className="fa fa-plus"></i> Add Address
                              </button>
                            </div>
                          )}
                        </div>
                        {props.getAddress.length ? (
                          <div style={{ padding: "20px 0" }}>
                            {props.getAddress &&
                              props.getAddress.map(
                                (add) =>
                                  props.firstAddress === add.id && (
                                    <div
                                      key={add.id}
                                      style={{
                                        borderColor: "#D3D3D3",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="addressradio"
                                        checked={props.selectAddress === add.id}
                                        onChange={() =>
                                          props.handleAddressSelect(add.id)
                                        }
                                      />
                                      &nbsp;&nbsp;
                                      {add.address_line1}, {add.address_line2},
                                      {add.address_city.city_name},
                                      {add.address_city.country_id === 1
                                        ? "Sri Lanka"
                                        : ""}
                                      , {add.postal_code}
                                    </div>
                                  ),
                              )}
                            {props.addressError}
                            {props.getAddress.length > 1 && (
                              <div className="collapeable_addresses_list">
                                <Collapsible
                                  trigger="View Other Addresses"
                                  transitionTime={200}
                                  onClosing={() =>
                                    props.setFirstAddress(props.selectAddress)
                                  }
                                >
                                  {props.getAddress.map(
                                    (add) =>
                                      props.firstAddress !== add.id && (
                                        <div
                                          key={add.id}
                                          style={{
                                            borderColor: "#D3D3D3",
                                            marginBottom: "8px",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            name="addressradio"
                                            checked={
                                              props.selectAddress === add.id
                                            }
                                            onChange={() =>
                                              props.handleAddressSelect(add.id)
                                            }
                                          />
                                          &nbsp;&nbsp;
                                          {add.address_line1},{" "}
                                          {add.address_line2},{" "}
                                          {add.address_city.city_name},
                                          {add.address_city.country_id === 1
                                            ? "Sri Lanka"
                                            : ""}
                                          , {add.postal_code}
                                        </div>
                                      ),
                                  )}
                                </Collapsible>
                              </div>
                            )}
                          </div>
                        ) : (
                          <p>{props.addressError}</p>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="form-section">
                    <div className="section-header-po">
                      <h4>
                        <i className="fa fa-tag"></i>
                        Order Notes
                      </h4>
                    </div>
                    {/* <Col md={12} style={{ marginTop: "40px" }}> */}
                    <div
                      style={{
                        padding: "16px",
                        display: "flex",
                        gap: "20px",
                        flexDirection: "column",
                      }}
                    >
                      <label style={{ marginRight: "20px" }}>
                        <input
                          type="checkbox"
                          checked={props.isChequeCollect}
                          onChange={(e) =>
                            props.setIsChequeCollect(e.target.checked)
                          }
                        />{" "}
                        Cheque Collect
                      </label>

                      <label style={{ marginRight: "20px" }}>
                        <input
                          type="checkbox"
                          checked={props.isReturnItem}
                          onChange={(e) =>
                            props.setIsReturnItem(e.target.checked)
                          }
                        />{" "}
                        Return Item
                      </label>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "30px",
                        }}
                      >
                        <label>
                          <input
                            type="checkbox"
                            checked={props.isCollectItem}
                            onChange={(e) =>
                              handleCollectItemChange(e.target.checked)
                            }
                          />{" "}
                          Collect Item
                        </label>
                        <Switch
                          checked={props.deliveryType === "2"}
                          onChange={(e) => {
                            props.setDeliveryType(e ? "2" : "1");
                          }}
                          disabled={!props.isCollectItem}
                          onColor="#6c757d"
                          offColor="#007bff"
                          onHandleColor="#007bff"
                          offHandleColor="#6c757d"
                          height={26}
                          width={86}
                          uncheckedIcon={
                            <div
                              style={{
                                alignItems: "center",
                                color: "white",
                                display: "flex",
                                fontSize: "11px",
                                fontWeight: "600",
                                height: "100%",
                                justifyContent: "center",
                                paddingRight: "30px",
                              }}
                            >
                              Standard
                            </div>
                          }
                          checkedIcon={
                            <div
                              style={{
                                alignItems: "center",
                                color: "white",
                                display: "flex",
                                fontSize: "11px",
                                fontWeight: "600",
                                height: "100%",
                                justifyContent: "center",
                                paddingLeft: "30px",
                              }}
                            >
                              Express
                            </div>
                          }
                          className="react-switch"
                          id="small-radius-switch"
                        />
                        <div
                          className="note-wrapper"
                          style={{
                            flex: "1",
                            maxWidth: "160px",
                          }}
                        >
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Payment Option"
                            isDisabled={!props.isCollectItem}
                            name="paymentoption"
                            value={props.paymentoption}
                            onChange={(value) => props.setPaymentoption(value)}
                            options={[
                              { value: "Cash", label: "Cash" },
                              { value: "Cheque", label: "Cheque" },
                              {
                                value: "Bank Transfer",
                                label: "Bank Transfer",
                              },
                              { value: "Hybrid", label: "Hybrid" },
                              { value: "ComBank", label: "ComBank" },
                              {
                                value: "Swap Machine",
                                label: "Swap Machine",
                              },
                              {
                                value: "Credit",
                                label: "Credit",
                              },
                            ]}
                          />
                          {props.paymentOptionError}
                        </div>

                        <label style={{ marginRight: "20px" }}>
                          <input
                            type="checkbox"
                            disabled={!props.isCollectItem}
                            checked={props.isInjectable}
                            onChange={(e) =>
                              props.setIsInjectable(e.target.checked)
                            }
                          />{" "}
                          Pay Later
                        </label>
                      </div>
                      {props.deliveryType === "2" && 
                        "This order will be received within 1 hour. Keep it as Standard if you do not need it urgently."}
                      {props.pickupTypeError}
                    </div>
                    {/* </Col> */}
                    <div className="section-content">
                      <div className="form-row">
                        <div className="note-wrapper" style={{ flex: "1" }}>
                          <label>NOTE</label>
                          <textarea
                            className="form-control"
                            placeholder="Note"
                            value={props.note}
                            onChange={(e) => props.setNote(e.target.value)}
                          />
                        </div>
                        {/* <Row style={{ marginLeft: "1px" }}></Row> */}
                      </div>
                    </div>
                  </div>

                  <div
                    className="form-actions"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <button
                      type="button"
                      className="btn-submit"
                      onClick={props.onSubmit}
                      disabled={props.loading}
                    >
                      {props.isEdit ? "Update" : "Submit"}
                    </button>
                    {props.isEdit && props.Status == 1 && (
                      <button
                        type="button"
                        className="btn btn-fill fl_text_purple"
                        style={{ marginLeft: "auto" }}
                        onClick={() =>
                          props.onUpdateReady && props.onUpdateReady("ready")
                        }
                        disabled={props.loading}
                      >
                        Update Ready
                      </button>
                    )}
                  </div>
                </form>
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};
export default AddPickUpOrder;
